import Role from '@/store/Role';

/**
 * A factory function for creating navigation guards against users based on permissions. Essentially, it checks to see if the user has the checkout permission
 * and if they don't have the preApplication role on the `beforeEnter` property in the router. See the router for examples.
 * @returns a function for managing permissions to that view
 */
export default function() {
	return (to, from, next) => {
		if (Role.hasGeneralPermission('checkout')) {
			// This means they're authorized. Let them through!
			next();
		} else if (Object.keys(Role.allPermissionsByRole).indexOf('preApplication') > -1) {
			// Check to see if they have the preApplication role, this means they need to be redirected to the application page
			next({
				name: 'application'
			});
		} else {
			// If they don't have the checkout permission and don't have the preApplication role, that means we want to show them the 404 page
			next({
				name: '404'
			});
		}
	};
}
